import { MaintenanceRequest } from "../../../types/types";
import { api } from "../api";

const maintenanceUpdateByVehicle = async (
    token: string,
    id: number,
    model: MaintenanceRequest
) => {
    const response = await api.put(
        `/maintenances/${id}`,
        {
            ...model
        },
        {
            headers: {
                Authorization:
                    `Bearer ${token}`
            }
        }
    );
    return response;
};

export default maintenanceUpdateByVehicle;